import { PartialTranslation } from '../translations';

export const sq: PartialTranslation = {
  newChat: 'Bisedë e re',
  search: 'Kërko',
  user: 'Përdoruesi',
  settings: 'Cilësimet',
  language: 'Gjuha',
  getHelp: 'Merr ndihmë',
  viewAllPlans: 'Shiko të gjitha planet',
  learnMore: 'Mëso më shumë',
  logOut: 'Dil',
  chooseLanguage: 'Zgjidh gjuhën',
  chooseYourPreferredLanguage: 'Zgjidhni gjuhën tuaj të preferuar',
  searchLanguages: 'Kërko gjuhë...',
  autoDetect: 'Zbulimi automatik',
  noLanguagesFound: 'Nuk u gjetën gjuhë',
  askAnything: 'Pyet çfarëdo gjëje',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'Personal',
  freePlan: 'Plan falas',
  current: 'Aktual',
  close: 'Mbylle',
  archive: 'Arkiv',
  delete: 'Fshi',
  confirmDelete: 'A jeni i sigurt që doni të fshini këtë bisedë?',
  confirmArchive: 'A jeni i sigurt që doni të arkivoni këtë bisedë?',
  deleteCannotUndo: 'Ky veprim nuk mund të zhbëhet.',
  archiveCanFind: 'Mund ta gjeni në listën e arkivit pas arkivimit.',
  resources: 'Burime',
  addResource: 'Shto burim',
  deleteResource: 'Fshi burim',
  noMatchingResourcesFound: 'Nuk u gjetën burime përkatëse',
  noResourcesAvailable: 'Nuk ka burime të disponueshme',
  hideResources: 'Fshih burimet',
  showResources: 'Trego burimet',
  typeMessage: 'Shkruaj mesazh...',
  thinkingOptions: 'Opsionet e mendimit',
  deleteFile: 'Fshi skedarin',
  clearSelection: 'Pastro përzgjedhjen',
  addAttachment: 'Shto bashkëngjitje',
  sendMessage: 'Dërgo mesazh',
  deepInsight: 'Kuptim i thellë · Analizë sipërfaqësore',
  deepInsightDesc: 'Kuptim i shpejtë i pikave kryesore',
  deepExploration: 'Eksplorimi i thellë · Analizë gjithëpërfshirëse',
  deepExplorationDesc: 'Kërkimi i thellë shumëdimensional',
  deepDeconstruction: 'Dekonstruksioni i thellë · Argument sistematik',
  deepDeconstructionDesc: 'Analizë progresive shtresë pas shtrese',
  contractReview: 'Rishikimi i kontratës · Identifikimi i rrezikut',
  contractReviewDesc: 'Analizë e klauzulave dhe kontroll pajtueshmërie',
  textPolish: 'Lustrim teksti · Shprehje profesionale',
  textPolishDesc: 'Optimizimi gjuhësor dhe rregullimi strukturor',
  legalDocuments: 'Dokumente ligjore · Projekt standard',
  legalDocumentsDesc: 'Shkrim profesional i dokumenteve ligjore',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'Hyr',
  register: 'Regjistrohu',
  welcomeBack: 'Mirësevini në LawHelper',
  loginSubtitle: 'Asistenti juaj AI për Kërkime Juridike',
  continueWithGoogle: 'Vazhdo me Google',
  continueWithMicrosoft: 'Vazhdo me Microsoft',
  continueWithWeChat: 'Vazhdo me WeChat',
  orContinueWith: 'ose vazhdo me',
  emailTab: 'Email',
  phoneTab: 'Telefon',
  emailPlaceholder: 'Shkruaj emailin tënd',
  phonePlaceholder: 'Shkruaj numrin e telefonit',
  codePlaceholder: 'Shkruaj kodin 6-shifror',
  sending: 'Duke dërguar...',
  verifying: 'Duke verifikuar...',
  verify: 'Verifiko',
  sendMagicLink: 'Dërgo lidhjen magjike',
  getVerificationCode: 'Merr kodin',
  resendCode: 'Ridërgo kodin',
  resendIn: 'Ridërgo pas',
  magicLinkSent: 'Lidhja magjike u dërgua në emailin tuaj',
  magicLinkHint: 'Do të dërgojmë një lidhje të sigurt në emailin tuaj',
  otpSent: 'Kodi i verifikimit u dërgua',
  agreeToTerms: 'Duke vazhduar, ju pranoni',
  privacyPolicy: 'Politika e Privatësisë',
  termsOfService: 'Kushtet e Shërbimit',
  and: 'dhe',
  privacyTitle: 'Privatësia juaj ka rëndësi',
  privacyIntro: 'Ne përdorim cookie dhe teknologji të ngjashme për të ofruar përvojën më të mirë.',
  essentialCookies: 'Cookie thelbësore',
  essentialDesc: 'Të nevojshme për funksionimin e faqes',
  analyticsCookies: 'Cookie analitike',
  analyticsDesc: 'Na ndihmojnë të përmirësojmë shërbimin',
  marketingCookies: 'Cookie marketingu',
  marketingDesc: 'Përdoren për përmbajtje të personalizuar',
  acceptAll: 'Prano të gjitha',
  essentialOnly: 'Vetëm thelbësoret',
  customize: 'Personalizo',
  savePreferences: 'Ruaj preferencat',
  back: 'Kthehu',
  readPrivacyPolicy: 'Lexo politikën tonë të privatësisë',
  cookiePolicy: 'Politika e Cookie',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'Rishikim AI',
  aiDraft: 'Draft AI',
  smartAssistant: 'Shablon',

  // 知识库搜索
  enableKnowledgeSearch: 'Aktivizo kërkimin',
  knowledgeSearchDesc: 'AI kërkon në dokumentet tuaja',
  clickToDisable: 'Çaktivizo',
  clickToEnable: 'Aktivizo',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Mbyll panelin e burimeve',
  uploading: 'Duke ngarkuar %{fileName}...',
  processing: 'Duke përpunuar %{fileName}...',
  uploadSuccess: '✓ %{fileName} u ngarkua',
  uploadError: '✗ Ngarkimi dështoi: %{error}',
  quickAnswer: 'Përgjigje e shpejtë',
  quickAnswerDesc: 'Përgjigje e shpejtë për pyetje të thjeshta',
  cancelRequest: 'Anulo',
  library: 'Bibliotekë',
  filterAll: 'Të gjitha',
  filterChat: 'Biseda',
  filterReview: 'Rishikim',
  filterDraft: 'Draft',
  filterTemplate: 'Shablon',
  filterForm: 'Formular',
  thinking: 'Duke menduar...',
  thinkingProcess: 'Procesi i mendimit',
  analyzingLegalLogic: 'Duke analizuar logjikën juridike...',
  lawhelperThinking: 'Lawhelper po mendon...',
  serviceError: 'Gabim shërbimi',
  uploaded: 'U ngarkua',
  settingsGeneral: 'Të përgjithshme',
  settingsNotifications: 'Njoftimet',
  settingsAppearance: 'Pamja',
  settingsProfile: 'Profili',
  settingsResponseNotifications: 'Njoftimet e përgjigjeve',
  settingsResponseNotificationsDesc: 'Njoftim kur AI përfundon përgjigjen',
  settingsColorMode: 'Mënyra e ngjyrave',
  settingsLight: 'E ndritshme',
  settingsDark: 'E errët',
  settingsSystem: 'Sistemi',
  about: 'Rreth',
  reviewTitle: 'Rishikimi i dokumentit',
  exitReview: 'Dil nga rishikimi',
  uploadPrompt: 'Ngarko PDF për rishikim',
  uploadButton: 'Zgjidh skedarin',
  startChatConfig: 'Shkruaj "Rishiko këtë dokument"',
  reviewPlaceholder: 'Shkruaj mesazh...',
  analyzing: 'Duke rishikuar...',
  reviewComplete: 'Rishikimi përfundoi',
  issuesFound: 'U gjetën %{count} probleme',
  draftTitle: 'Hartimi i dokumentit ligjor',
  draftPlaceholder: 'Redakto këtu ose kërko nga AI...',
  analyzingTemplate: 'Duke analizuar shabllonin %{name}...',
  templateAnalyzed: '✅ Shablloni %{name} u analizua!',
  templateAnalysisPrompt: 'Analizo klauzolat kryesore',
  parsingFailed: '⚠️ Skedari nuk u analizua.',
  generating: 'Duke gjeneruar...',
  generatedSuccess: '✅ Dokumenti u gjenerua!',
  drafterWelcome: 'Mirësevini në Asistentin AI të Dokumenteve',
  drafterYouCan: 'Mund të:',
  drafterUploadTemplate: 'Ngarkoni shabllonin për analizë AI',
  drafterDescribeNeeds: 'Përshkruani kërkesat e dokumentit',
  drafterLetAiHelp: 'AI ndihmon me kontrata, marrëveshje etj.',
  drafterExamples: 'Shembuj:',
  drafterExampleRental: '"Hartoni kontratë qiraje"',
  drafterExampleLabor: '"Plotësoni kontratën e punës"',
  drafterInputPlaceholder: 'Përshkruani nevojat...',
  drafterThinking: 'Duke menduar...',
  drafterHistoryTitle: 'Historia',
  drafterNoHistory: 'Nuk ka histori',
  drafterNewChat: 'Bisedë e re',
  drafterHistory: 'Historia',
  drafterRemoveAttachment: 'Hiq bashkëngjitjen',
  drafterLineHeight: 'Lartësia e rreshtit',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Eksporto si Word (.docx)',
  drafterExportPdf: 'Eksporto si PDF',
  drafterSave: 'Ruaj dokumentin',
  drafterDownload: 'Shkarko dokumentin',
  drafterUndo: 'Zhbëj',
  drafterRedo: 'Ribëj',
  drafterBold: 'Bold',
  drafterItalic: 'Italic',
  drafterStrike: 'I fshirë',
  drafterUnderline: 'I nënvizuar',
  drafterHighlight: 'Thekso',
  drafterLink: 'Fut lidhje',
  drafterAlignLeft: 'Majtas',
  drafterAlignCenter: 'Qendër',
  drafterAlignRight: 'Djathtas',
  drafterAlignJustify: 'Justifiko',
  drafterList: 'Listë',
  drafterBulletList: 'Listë me pika',
  drafterOrderedList: 'Listë e numëruar',
  drafterTaskList: 'Listë detyrash',
  drafterOpenResource: 'Hap burimet',
  drafterStopGeneration: 'Ndalo gjenerimin',
  drafterAgentMode: 'Modaliteti agjent aktiv',
  drafterAgentModeOn: 'Modaliteti agjent aktiv',
  drafterAgentModeOff: 'Modaliteti normal',
  drafterUploadAttachment: 'Ngarko bashkëngjitje',
  drafterExit: 'Dil',
  drafterConfirm: 'Konfirmo',
  drafterOpenLink: 'Hap lidhjen',
  drafterDeleteLink: 'Fshi lidhjen',
  drafterQuote: 'Citim',
  workflowTitle: 'Rrjedha AI',
  workflowRunning: 'Duke ekzekutuar...',
  workflowReady: 'Gati',
  workflowCompleted: 'Përfundoi',
  workflowStartFailed: 'Nisja e rrjedhës dështoi',
  workflowExecutionFailed: 'Ekzekutimi dështoi',
  workflowInterrupted: 'Rrjedha u ndërpre',
  workflowProcessing: 'Duke përpunuar...',
  workflowStepsCompleted: 'hapa të përfunduar',
  workflowStepsTotal: 'Rrjedha përfundoi (%{count} hapa)',
  acceptChanges: 'Prano ndryshimet',
  rejectChanges: 'Refuzo ndryshimet',
  changesAccepted: 'Ndryshimet u pranuan',
  changesRejected: 'Ndryshimet u refuzuan',
  stopWorkflow: 'Ndalo',
  restartWorkflow: 'Rinise',
  startDrafting: 'Fillo hartimin',
  interrupt: 'Ndalo',
  documentSubject: 'Tema e dokumentit *',
  documentType: 'Lloji i dokumentit',
  jurisdiction: 'Juridiksioni',
  specialRequirements: 'Kërkesa speciale (opsionale)',
  clickStartDrafting: 'Kliko "Fillo hartimin"',
  docTypeContract: 'Kontratë',
  docTypeAgreement: 'Marrëveshje',
  docTypeNotice: 'Njoftim',
  docTypeLetter: 'Letër',
  docTypePetition: 'Peticion',
  docTypeWill: 'Testament',
  docTypePowerOfAttorney: 'Prokurë',
  countryChina: 'Kinë',
  countryUSA: 'SHBA',
  countryGermany: 'Gjermani',
  countryJapan: 'Japoni',
  countryFrance: 'Francë',
  countryUK: 'Mbretëria e Bashkuar',
  citationVerified: 'I verifikuar',
  citationUnverified: 'I paverifikuar',
  imageLoadFailed: 'Imazhi nuk u ngarkua',
  smartDocTitle: 'Asistenti inteligjent',
  smartDocChatTitle: 'Asistenti AI i dokumenteve',
  smartDocDropPrompt: 'Hidh PDF këtu',
  smartDocSelectFile: 'Zgjidh skedarin',
  smartDocOr: 'ose',
  smartDocWelcomeTitle: 'Mirësevini në Asistentin AI',
  smartDocWelcomeYouCan: 'Mund të:',
  smartDocUploadForAI: 'Ngarkoni shabllonin',
  smartDocDescribeDoc: 'Përshkruani kërkesat',
  smartDocLetAIDraft: 'AI ndihmon me kontrata',
  smartDocExamples: 'Shembuj:',
  smartDocExampleRental: '"Hartoni kontratë qiraje"',
  smartDocExampleLabor: '"Plotësoni kontratën e punës"',
  smartDocInputPlaceholder: 'Përshkruani nevojat...',
  smartDocRemoveAttachment: 'Hiq bashkëngjitjen',
  smartDocOpenResources: 'Hap burimet',
  smartDocExit: 'Dil',
  reviewStartFailed: 'Nisja e rishikimit dështoi',
  reviewFailed: 'Rishikimi dështoi',
  reviewFoundIssues: 'Rishikimi përfundoi, %{count} probleme.',
  cannotReadStream: 'Nuk mund të lexohet rrjedha',
  parseEventFailed: 'Analiza e ngjarjes dështoi',
  errorPrefix: 'Gabim',
  unknownError: 'Gabim i panjohur',
  file: 'Skedar',
  loading: 'Duke ngarkuar...',
  localFolders: 'Dosjet lokale',
  selectLocalFolder: 'Zgjidh dosjen lokale',
  reselectFolder: 'Ndrysho dosjen',
  addToContext: 'Shto në bisedë',
  saveFile: 'Ruaj',
  renameFile: 'Riemërto',
  fileSaved: 'Skedari u ruajt',
  fileRenamed: 'Skedari u riemërtua në %{name}',
  browserNotSupported: 'Shfletuesi nuk mbështet qasjen në dosje',
  noFolderSelected: 'Zgjidhni dosje lokale',
  scanningFolder: 'Duke skanuar dosjen...',
  selectFileToPreview: 'Zgjidhni skedar për parapamje',
  aiAnalyze: 'Analizë AI',
};
